import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Headerdash from '../components/dashboard/layout/Headerdash';
import Sidebar from '../components/dashboard/layout/Sidebar';
import Footerdash from '../components/dashboard/layout/Footerdash';
import Dashboardhome from '../components/dashboard/Dashboardhome';
import Retailers from '../components/dashboard/Retailers';
import ChanageHomeContent from '../components/dashboard/ChanageHomeContent';
import Guests from '../components/dashboard/Guests';
import PayUTransaction from '../components/dashboard/PayUTransaction';
import RetailersTransactionReport from '../components/dashboard/RetailersTransactionReport';
import Notifications from '../components/dashboard/Notifications';
import AddressUpdate from '../components/dashboard/AddressUpdate';

import RiseTicket from '../components/dashboard/RiseTicket';
import OpenNewTicket from '../components/dashboard/OpenNewTicket';
import UserProfile from '../components/dashboard/UserProfile';
import Activities from '../components/dashboard/Activities';
import CloseTicket from '../components/dashboard/CloseTicket';

import NewPanApplication from '../components/dashboard/Forms/NewPanApplication';
import CorrectionPanApplication from '../components/dashboard/Forms/CorrectionPanApplication';
import NamePublication from '../components/dashboard/Forms/NamePublication';
import PANObject from '../components/dashboard/Forms/PANObject';
import PanFind from '../components/dashboard/Forms/PanFind';
import CAMPRegistration from '../components/dashboard/Forms/CAMPRegistration';
import AddApplicants from '../components/dashboard/Forms/AddApplicants'; // your new page

import CAMPRegistrationReport from '../components/dashboard/Report/CAMPRegistrationReport';
import PublicationReport from '../components/dashboard/Report/NamePublicationReport';
import NewPanApplicationReport from '../components/dashboard/Report/NewPanApplicationReport';
import CorrectionPanApplicationReport from '../components/dashboard/Report/CorrectionPanApplicationReport';
import PANObjectReport from '../components/dashboard/Report/PANObjectReport';
import PanFindReport from '../components/dashboard/Report/PanFindReport';
import AddressUpdateReport from '../components/dashboard/Report/AddressUpdateReport';

import CAMPRegistrationCompleteReport from '../components/dashboard/AdminCompleteReport/CAMPRegistrationCompleteReport';
import NamePublicationCompleteReport from '../components/dashboard/AdminCompleteReport/NamePublicationCompleteReport';
import NewPanApplicationCompleteReport from '../components/dashboard/AdminCompleteReport/NewPanApplicationCompleteReport';
import CorrectionPanApplicationCompleteReport from '../components/dashboard/AdminCompleteReport/CorrectionPanApplicationCompleteReport';
import PANObjectCompleteReport from '../components/dashboard/AdminCompleteReport/PANObjectCompleteReport';
import PanFindCompleteReport from '../components/dashboard/AdminCompleteReport/PanFindCompleteReport';
import AddressUpdateCompleteReport from '../components/dashboard/AdminCompleteReport/AddressUpdateCompleteReport';

import NewPanApplicationAdminReport from '../components/dashboard/AdminReport/NewPanApplicationAdminReport';
import CorrectionPanApplicationAdminReport from '../components/dashboard/AdminReport/CorrectionPanApplicationAdminReport';
import NamePublicationAdminReport from '../components/dashboard/AdminReport/NamePublicationAdminReport';
import PANObjectAdminReport from '../components/dashboard/AdminReport/PANObjectAdminReport';
import CAMPRegistrationAdminReport from '../components/dashboard/AdminReport/CAMPRegistrationAdminReport';
import PanFindAdminReport from '../components/dashboard/AdminReport/PanFindReportAdmin';
import AddressUpdateAdminReport from '../components/dashboard/AdminReport/AddressUpdateAdminReport';

const Dashboard = () => {

  const [isMinified, setIsMinified] = useState(false);
  const toggleSidebar = () => {
    setIsMinified(!isMinified);
  };

  return (
    <div className={`wrapper ${isMinified ? 'sidebar-minified' : ''}`}>
      <Sidebar isMinified={isMinified} />
      <div className="page-wrapper">
        <Headerdash toggleSidebar={toggleSidebar} />
        <div className="content-wrapper">
          <div className="content">
            <Routes>
              {/* Child routes of /dashboard */}
              <Route path="/" element={<Dashboardhome />} />
              <Route path="retailers" element={<Retailers />} />
              <Route path="guests" element={<Guests />} />
              <Route path="pay-u-transaction" element={<PayUTransaction />} />
              <Route path="retailor-transaction-report" element={<RetailersTransactionReport />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="address-update" element={<AddressUpdate />} />
              <Route path="rise-ticket" element={<RiseTicket />} />
              <Route path="open-new-ticket" element={<OpenNewTicket />} />
              <Route path="close-ticket" element={<CloseTicket />} />
              <Route path="user-profile" element={<UserProfile />} />
              <Route path="activities" element={<Activities />} />
              <Route path="*" element={<Dashboardhome />} />
              <Route path="chanage-home-content" element={<ChanageHomeContent />} />

              <Route path="new-pan-application" element={<NewPanApplication />} />
              <Route path="correction-pan-application" element={<CorrectionPanApplication />} />
              <Route path="name-publication" element={<NamePublication />} />
              <Route path="pan-object" element={<PANObject />} />
              <Route path="pan-find" element={<PanFind />} />
              <Route path="camp-registration" element={<CAMPRegistration />} />
              <Route path="/" element={<CAMPRegistration />} />
              <Route path="/add-applicants" element={<AddApplicants />} />

              <Route path="new-pan-application-report" element={<NewPanApplicationReport />} />
              <Route path="camp-registration-report" element={<CAMPRegistrationReport />} />
              <Route path="name-publication-report" element={<PublicationReport />} />
              <Route path="pan-object-report" element={<PANObjectReport />} />
              <Route path="pan-find-report" element={<PanFindReport />} />
              <Route path="correction-pan-application-report" element={<CorrectionPanApplicationReport />} />
              <Route path="new-address-report" element={<AddressUpdateReport />} />

              <Route path="new-pan-application-complete-report" element={<NewPanApplicationCompleteReport />} />
              <Route path="camp-registration-complete-report" element={<CAMPRegistrationCompleteReport />} />
              <Route path="name-publication-complete-report" element={<NamePublicationCompleteReport />} />
              <Route path="pan-object-complete-report" element={<PANObjectCompleteReport />} />
              <Route path="pan-find-complete-report" element={<PanFindCompleteReport />} />
              <Route path="correction-pan-application-complete-report" element={<CorrectionPanApplicationCompleteReport />} />
              <Route path="address-update-complete-report" element={<AddressUpdateCompleteReport />} />

              <Route path="camp-registration-admin-report" element={<CAMPRegistrationAdminReport />} />
              <Route path="correction-pan-application-admin-report" element={<CorrectionPanApplicationAdminReport />} />
              <Route path="name-publication-admin-report" element={<NamePublicationAdminReport />} />
              <Route path="new-pan-application-admin-report" element={<NewPanApplicationAdminReport />} />
              <Route path="pan-find-admin-report" element={<PanFindAdminReport />} />
              <Route path="pan-object-admin-report" element={<PANObjectAdminReport />} />
              <Route path="new-address-admin-report" element={<AddressUpdateAdminReport />} />

            </Routes>
          </div>
        </div>
        <Footerdash />
      </div>
    </div>
  );
};
export default Dashboard;
